export const storage = {
    ru: async () =>  [
        (await import("./storage-post-files.ru.js")).default,
        (await import("./storage-patch-files-file_id.ru.js")).default,
        (await import("./storage-get-files.ru.js")).default,
        (await import("./storage-get-files-file_id.ru.js")).default,
        (await import("./storage-delete-files-file_id.ru.js")).default
    ],
    en: async () =>  [
        (await import("./storage-post-files.en.js")).default, 
        (await import("./storage-patch-files-file_id.en.js")).default,
        (await import("./storage-get-files.en.js")).default,
        (await import("./storage-get-files-file_id.en.js")).default,
        (await import("./storage-delete-files-file_id.en.js")).default
    ]
}
